import type * as React from "react";
import { cn } from "@/lib/utils";
import { CloseIcon } from "../../icons/close-icon";

/**
 * The close control, and the only cross the partner UI draws.
 *
 * Figma `close` 2174:20280: a 32px square, 8px radius, white on a 1px #E5E5E5
 * border, holding a 16px glyph whose cross spans 8px in #364153 at a 1.5px
 * round-capped stroke. {@link CloseIcon} is drawn on a 16-unit grid, so at
 * `size-4` its 4→12 path is that 8px cross at exactly 1.5px — no scaling
 * correction needed.
 */
export function CloseButton({
	className,
	label = "Close",
	...props
}: Omit<React.ComponentProps<"button">, "children"> & { label?: string }) {
	return (
		<button
			type="button"
			aria-label={label}
			className={cn(
				"flex size-8 shrink-0 items-center justify-center rounded-[8px] border border-[#e5e5e5] bg-white text-[#364153]",
				className,
			)}
			{...props}
		>
			<CloseIcon aria-hidden="true" className="size-4" />
		</button>
	);
}
